// @flow
import * as React from 'react';
import { Input, Button } from '../../common/components/core';
import LoggedoutActions from '../../main/actions/LoggedoutActions';
import LoggedoutStore from '../../main/stores/LoggedoutStore';
import { emailValid } from './ScreenSignupValidation';

type Props = {};

type State = {
  errorMessage: string,
  email: string,
  resendVerificationSuccess: boolean,
  errors: Object,
  showError: boolean,
  errorMessage: string
};

class ScreenResendEmail extends React.Component<Props, State> {
  state = {
    email: '',
    resendVerificationSuccess: LoggedoutStore.resendVerificationSuccess(),
    errors: {},
    showError: false,
    errorMessage: ''
  };

  componentDidMount() {
    LoggedoutStore.addChangeListener(this._onChange);
    LoggedoutActions.clearErrors();
  }

  componentWillUnmount() {
    LoggedoutStore.removeChangeListener(this._onChange);
  }

  _onChange = () => {
    const resendVerificationSuccess = LoggedoutStore.resendVerificationSuccess();
    const errors = LoggedoutStore.getErrors();
    const showError = errors.data ? true : false;
    let errorMessage = errors.statusText;
    if (errors.status === 429) {
      errorMessage =
        'Looks like you have exceeded the amount of requests. Please try again after sometime.';
    }
    this.setState({
      resendVerificationSuccess,
      errors,
      showError,
      errorMessage
    });
  };

  _onDataChange = (key: string) => {
    return (ev: any) => {
      this.setState({ [key]: ev.value });
    };
  };

  _handleResendClicked = () => {
    if (emailValid(this.state.email)) {
      LoggedoutActions.resendVerificationEmail(this.state.email);
    } else {
      this.setState({
        showError: true,
        errorMessage: 'Please enter a valid email'
      });
    }
  };

  render() {
    const resendInput = !this.state.resendVerificationSuccess && (
      <div>
        <div className="row">
          <div className="col-sm-4 accept-image">
            <Input
              onChange={this._onDataChange('email')}
              value={this.state.email}
              name="email"
              label="Email address"
              testid="verify-email__email-address"
            />
          </div>
        </div>
        <div>
          <Button
            className="btn-email-verify-continue"
            onClick={this._handleResendClicked}
            testid="verify-email__resend-email"
          >
            Resend email
          </Button>
        </div>{' '}
      </div>
    );

    const resendTitle = !this.state.resendVerificationSuccess
      ? 'Resend Email'
      : 'Email Sent';
    const resendText = !this.state.resendVerificationSuccess
      ? `If you have not received the verification email yet or if your token has expired, you can enter
  your email address below and we'll resend the verification email.`
      : 'Verification link has been successfully sent to your email. Please make sure that you check your Inbox and Spam box.';

    const headerImage = !this.state.resendVerificationSuccess ? (
      <img
        className="accept-image"
        src="https://res.cloudinary.com/dzeo8q4va/image/upload/v1577428920/img_verify.png"
      />
    ) : (
      <img
        className="accept-image"
        src="https://res.cloudinary.com/dzeo8q4va/image/upload/v1579539733/img_emailSent.png"
      />
    );

    return (
      <div className="accept-invite-container">
        <div className="accept-invite-header">
          <img
            className="branch-logo"
            src="/static/images/branch-logos/branch-logo_dark.svg"
          />
        </div>
        <div>
          {headerImage}
          <h1 className="verify-email">{resendTitle}</h1>
          <p className="email-instructions">{resendText}</p>
          <br></br>
          <br></br>
          {resendInput}
          {this.state.showError ? (
            <div className="email-footer">
              <p className="email-warning">{this.state.errorMessage}</p>
            </div>
          ) : (
            <div className="email-footer"></div>
          )}
        </div>
      </div>
    );
  }
}

export default ScreenResendEmail;
